import { render, staticRenderFns } from "./logsPage.vue?vue&type=template&id=52e7b383&scoped=true&"
import script from "./logsPage.vue?vue&type=script&lang=js&"
export * from "./logsPage.vue?vue&type=script&lang=js&"
import style0 from "./logsPage.vue?vue&type=style&index=0&id=52e7b383&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e7b383",
  null
  
)

export default component.exports